module.exports = __webpack_public_path__ + "img/BH4-MAJ-EXT-lowres-1043.93e748ee.jpg";